import React, { useState, useEffect } from "react";
import useSiteState from '../appState/siteState/useSiteState';

const EliminatedWeekly = props => {
    const WeeklyEliminationData = props?.WeeklyEliminationData ?? []
    return (
        <>
           

            {
                WeeklyEliminationData && WeeklyEliminationData.firstWeek ? <li>Week {WeeklyEliminationData.firstWeek}:  {WeeklyEliminationData.firstWeekElimination}
                    {WeeklyEliminationData.firstWeekElimination > 1 ? ' Users ' : ' User '}
                </li> : ""
            }

            {
                WeeklyEliminationData && WeeklyEliminationData.midWeekRange && !WeeklyEliminationData.firstHalfEliminationOtherThanfirstWeek ? <li>Week {WeeklyEliminationData.midWeekRange}:   1 User
                </li> : ""
            }

            {
                WeeklyEliminationData && WeeklyEliminationData.firstHalfEliminationOtherThanfirstWeek ? <li>Week {WeeklyEliminationData.midWeekRange}:  {WeeklyEliminationData.firstHalfEliminationOtherThanfirstWeek}
                    {WeeklyEliminationData.firstHalfEliminationOtherThanfirstWeek > 1 ? ' Users ' : ' User '}
                </li> : ""
            }

            {
                WeeklyEliminationData && WeeklyEliminationData.lastWeekRange ? <li>Week {WeeklyEliminationData.lastWeekRange}:  1 User</li> : ""
            }
        </>
    );

}

export default (EliminatedWeekly);
